import React from 'react';
import PropTypes from 'prop-types';

const LastMinuteGiftIcon = props => (
	<svg
		width={75}
		height={60}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M28 60c9.389 0 17-.672 17-1.5S37.389 57 28 57s-17 .672-17 1.5S18.611 60 28 60Z"
			fill="#E6E6E6"
		/>
		<path
			d="M18.982 17.736 7.553 35.979l3.475 14.413 36.167-8.804-3.474-14.413-18.47-10.965a4.607 4.607 0 0 0-3.443-.516 4.628 4.628 0 0 0-2.826 2.042Z"
			fill="#8AE1E3"
		/>
		<path
			d="m36.929 16.373-28.253 6.88 6.621 27.461 28.253-6.88-6.621-27.461Z"
			fill="url(#a)"
		/>
		<path
			d="M29.134 46.09 7.554 35.98l4.834 20.058 11.173-2.72 13.82-3.365 11.172-2.72-4.835-20.058L29.134 46.09Z"
			fill="#fff"
		/>
		<path
			d="M29.134 46.09 7.554 35.98l4.834 20.058 11.173-2.72 13.82-3.365 11.172-2.72-4.835-20.058L29.134 46.09Z"
			fill="#B1F0F2"
		/>
		<path
			d="m29.134 46.09-6.69-3.135-10.056 13.083 11.173-2.72 13.82-3.365 11.173-2.72-14.898-7.008-4.521 5.865Z"
			fill="#38BFC3"
			style={{ mixBlendMode: "multiply", }}
			opacity={0.2}
		/>
		<path
			d="M27.591 39.69 12.388 56.039l36.166-8.805L27.59 39.69Z"
			fill="#D5F6F7"
		/>
		<path
			d="M28.884 25.046a2.914 2.914 0 0 0-4.021.98l-.404.665-.663-.406a2.914 2.914 0 0 0-2.212-.348 2.928 2.928 0 0 0-1.81 1.327 2.954 2.954 0 0 0 .974 4.042l.663.406 4.996 3.063 3.047-5.021.405-.666a2.954 2.954 0 0 0 .345-2.223 2.94 2.94 0 0 0-1.32-1.819Z"
			fill="#FF5D52"
		/>
		<path
			stroke="#FF5D52"
			strokeWidth={1.5}
			strokeLinecap="round"
			d="m20.637 10.864-.89-3.487M37.775 5.472l-1.294 5.633M29.666.792l-.439 7.543M8.566 11.295l3.413 4.579M1.041 20.345l2.906 1.95"
		/>
		<defs>
			<linearGradient
				id="a"
				x1={25}
				y1={31.5}
				x2={28.025}
				y2={42.493}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#fff" />
				<stop offset={1} stopColor="#DDD" />
			</linearGradient>
		</defs>
	</svg>
);

export default LastMinuteGiftIcon;